const toTitleCase = (s) => {
  const safe = (s || "").toString().trim();
  if (!safe) return "";
  return safe
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export const formatCustomFieldLabel = (key) => {
  const raw = (key || "").toString().trim();
  if (!raw) return "";

  const rawLower = raw.toLowerCase();
  const rawLowerNoUnderscore = rawLower.replace(/[_.\s]/g, "");

  // Explicit fixes for known field keys coming from doctype_fields_data
  const explicit = {
    issuedate: "Issue Date",
    approvaldate: "Approval Date",
    documentsummary: "Document Summary",
    noofworkers: "No. of Workers",
    numberofworkers: "No. of Workers",
    numberworkers: "No. of Workers",
    neverexpire: "Never Expire",
    never_expire: "Never Expire",
  };
  if (explicit[rawLower]) return explicit[rawLower];
  if (explicit[rawLowerNoUnderscore]) return explicit[rawLowerNoUnderscore];

  // Generic: split camelCase / PascalCase / snake_case into words and title-case.
  const spaced = raw
    .replace(/_/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim();

  return toTitleCase(spaced);
};
